<template>
  <!-- 章节列表 -->
  <section class="video-list">

    <ul>
      <li v-for="(list, index) in chapterList" :key="index">
        <div v-if="list.type === 1">
          <div class="chapter" @click="showSection(list, index)">
            <em class="chapter-index">{{ index + 1 < 10 ? '0' + (index + 1) : index }}</em>
                <p>{{ list.name }}</p>
                <i v-if="list.childrenList.length > 0" :class="{ 'toggle-icon': true, 'show': !list.showFlag }"></i>
          </div>
          <!-- 课次列表 -->
          <el-collapse-transition>
            <ul class="lesson-ul" v-if="!list.showFlag">
              <li v-for="(item, itemIndex) in list.childrenList" :key="itemIndex"
                @click="playHandle(list.id, item, 'immediately')">
                <img v-if="item.lessonAudioVideo && !item.playing" :src="item.isFinish === 1 ? videoEdIcon : videoIcon"
                  alt="视频">
                <img v-if="item.playing" src="@/assets/image/video-playgif.gif" alt="正在播放">
                <div v-if="!item.lessonAudioVideo && !item.playing" class="empty-box"></div>
                <span :class="{ 'class-name': true, 'active': item.playing, 'played': item.isFinish === 1 }">{{
                  item.name }}</span>
                <div>
                  <i :class="iconClass(item)"></i>
                </div>
              </li>
            </ul>
          </el-collapse-transition>
        </div>
        <ul class="lesson-ul chapter-lesson" v-if="list.type === 4">
          <li @click="playHandle(list.id, list, 'immediately')">
            <img v-if="list.lessonAudioVideo && !list.playing" :src="list.isFinish === 1 ? videoEdIcon : videoIcon"
              alt="视频">
            <img v-if="list.playing" src="@/assets/image/video-playgif.gif" alt="正在播放">
            <div v-if="!list.lessonAudioVideo && !list.playing" class="empty-box"></div>
            <span :class="{ 'class-name': true, 'active': list.playing, 'played': list.isFinish === 1 }">{{ list.name
            }}</span>
            <div>
              <i :class="iconClass(list)"></i>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<script>
  import { courseStore } from "@/store/course.js";
  export default {
    name: 'CourseVideoList',
    props: {
      dataList: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        store: courseStore(),
        videoIcon: require('@/assets/image/videoPlaying.png'),
        videoEdIcon: require('@/assets/image/videoPlay2.png'),
        // 章节列表
        chapterList: [],
        timer: null,
      }
    },
    watch: {
      dataList(val) {
        this.chapterList = val

      const courseInfo = this.store.getCourseInfo
      const lessonInfo = {
        id: courseInfo.lessonId,
        name: courseInfo.lessonName,
        lessonAudioVideo: courseInfo.lessonAudioVideo
      }
      
      // 初始化目录
      this.playHandle(courseInfo.chapterId, lessonInfo, 'doNot')



      }
    },
    mounted() {
      // 拿课次相关信息
      // this.chapterList = this.dataList

      if(this.dataList.length>0){
         this.chapterList = this.dataList
        const courseInfo = this.store.getCourseInfo
      const lessonInfo = {
        id: courseInfo.lessonId,
        name: courseInfo.lessonName,
        lessonAudioVideo: courseInfo.lessonAudioVideo
      }
      
      // 初始化目录
      this.playHandle(courseInfo.chapterId, lessonInfo, 'doNot')
      }

    },
    methods: {

      // 展开/收起课程详情
      showSection(list, i) {
        this.$set(this.chapterList[i], 'showFlag', !list.showFlag)
      },

      // 目录图标
      iconClass(list) {
        if (list.playing) {
          return 'inProgress'
        } else {
          if (list.isFinish === 1) {
            return 'accomplish'
          } else {
            if (list.lessonAudioVideo) {
              if (list.lessonAudioVideo?.duration && list.lessonAudioVideo.duration > 0) {
                return 'inProgress'
              } else {
                return 'unfinished'
              }
            }
          }
        }
      },

      // 创造播放列表，自动播放下一个
      createdPlayList(endLessonId) {
        let arr = []
        this.chapterList.forEach(list => {
          if (list.type === 1) {
            if (list.childrenList) {
              list.childrenList.forEach(item => {
                arr.push({
                  chapterId: list.id,
                  id: item.id,
                  name: item.name,
                  lessonAudioVideo: item.lessonAudioVideo
                })
              })
            }
          } else if (list.type === 4) {
            arr.push({
              chapterId: list.id,
              id: list.id,
              name: list.name,
              lessonAudioVideo: list.lessonAudioVideo
            })
          }
        })

        // 匹配到当前播放的，去播放下一个
        if (arr.length > 0 && endLessonId) {
          arr.forEach((p, i) => {
            if (p.id === endLessonId) {
              if (i !== arr.length - 1) {
                const next = arr[i + 1]
                if (next.lessonAudioVideo) {
                  if (next.lessonAudioVideo.type === 2 && next.lessonAudioVideo.url != '') {
                    this.playHandle(next.chapterId, next, 'immediately')
                  } else {
                    // 为音频时->给与提示
                    this.$message.error('暂无可播放的视频资源')
                    this.playHandle(next.chapterId, next, 'doNot')
                    this.timer = setTimeout(() => {
                      // 递归往下找
                      this.createdPlayList(next.id)
                    }, 3000);
                  }
                } else {
                  this.playHandle(next.chapterId, next, 'doNot')
                  // 递归往下找
                  this.timer = setTimeout(() => {
                    this.createdPlayList(next.id)
                  }, 3000);
                }
              } else {
                console.log('已播放完所有视频，请返回目录选择其他课程')
              }
            }
          })
        }
      },

      // 播放
      playHandle(chapterId, lessonInfo, type) {
        console.log(chapterId, lessonInfo, type,"====")

        // 如有自动播放队列在执行，则阻止
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }

        if (lessonInfo.lessonAudioVideo) {
          if (lessonInfo.lessonAudioVideo.type === 2) {
            const courseInfo = this.store.getCourseInfo
            // 存储播放所需的相关id
            const courseInfoNew = {
              projectId: courseInfo.projectId,
              orderId: courseInfo.orderId,
              newestLessonId: courseInfo.newestLessonId,
              duration: courseInfo.duration,
              courseId: courseInfo.courseId,
              chapterId: chapterId,
              lessonId: lessonInfo.id,
              lessonName: lessonInfo.name,
              lessonAudioVideo: lessonInfo.lessonAudioVideo
            }
            this.store.setCourseInfo(courseInfoNew)
            localStorage.setItem('courseInfo', JSON.stringify(courseInfoNew))

            // 通知父级播放视频->立即播放视频
            if (type === 'immediately') this.$emit('lessonChange', 'play')
            else this.$emit('lessonChange', '') // 只告知父组件切换课次名，什么都不做

          } else {
            // 为音频时->给与提示
            this.$message.error('暂无可播放的视频资源')
          }
        } else {
          this.$message.error('暂无可播放资源')
          // TODO: 这里的 [return] 会阻断渲染当前选中状态，在遇到无资源的课次时会停止
          // return
        }


        // 筛选选中课程 标记播放状态
        let temp = this.clearPlayStatus(this.chapterList)

        // (严格目录层级时可取)
        // temp.find(list => list.courseId === courseId).childrenList
        //   .find(chapter => chapter.id === chapterId).childrenList
        //   .find(lesson => lesson.id === lessonId).playing = true

        // 课次层级不固定时可取
        temp.forEach(list => {
          if (list.id === chapterId) {
            if (list.type === 1) {
              list.childrenList.forEach(lesson => {
                console.log(lessonInfo.id,'111111')
                if (lesson.id === lessonInfo.id) {
                  lesson.playing = true
                }
              })
            } else if (list.type === 4) {
              console.log(list.playing,'2222')
              list.playing = true
              return
            }
          }
        })

        this.chapterList = [...temp]

      },

      // 重置播放状态
      clearPlayStatus(data) {
        data.forEach(list => {
          if (list.type === 4) {
            list.playing = false
          } else {
            if (list.childrenList && list.childrenList.length > 0) {
              list.childrenList.forEach(item => {
                item.playing = false
              })
            }
          }
        })
        return data
      },
    }
  }
</script>

<style lang="scss" scoped>

  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .video-list {
    overflow-x: hidden;
    overflow-y: auto;
    margin: 19px 20px;
    color: #fff;
    font-size: $content-font-size;
    font-weight: 400;

    .chapter {
      padding: 0 15px;
      width: 344px;
      height: 54px;
      line-height: 54px;
      background: rgba(0, 0, 0, 0.25);
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(241, 243, 248, 0.15);

      .chapter-index {
        color: #bcc4d2;
        font-style: normal;
        margin-right: 12px;
      }

      p {
        width: 280px;
        color: #bcc4d2;
        margin-right: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .toggle-icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url("@/assets/image/videoArrowDown.png");
        background-repeat: no-repeat;
        background-size: cover;

        &.show {
          background-image: url("@/assets/image/videoArrowUp.png");
        }
      }

      img {
        width: 24px;
        height: 24px;
      }
    }

    .lesson-ul {
      padding: 0 15px 0 42px;

      li {
        display: flex;
        height: 64px;
        align-items: center;
        border-bottom: 1px solid rgba(241, 243, 248, 0.1);

        &:last-child {
          span {
            border: none;
          }
        }

        .class-name {
          flex: 1;
          font-size: 14px;
          line-height: 20px;
          margin-left: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;

          &.active {
            color: $theme-color !important;
          }

          &.played {
            color: $grey-font-color;
          }
        }

        img,
        i {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: 100% 100%;

          &.unfinished {
            background-image: url("@/assets/image/unfinished.png");
          }

          &.accomplish {
            background-image: url("@/assets/image/accomplish.png");
          }

          &.inProgress {
            background-image: url("@/assets/image/inProgress.png");
          }
        }

        .empty-box {
          width: 16px;
          height: 16px;
        }
      }
    }

    .chapter-lesson {
      padding: 0 15px;
    }
  }
</style>